(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-product-tbyb"] && !Shopify.designMode) return;
  try {
    

(function () {

  var CLEAR_CART_BEFORE_ADD = true;

  var SUBSCRIPTION_EBOOK_VARIANT_ID =
    54686607606083;

  var SUBSCRIPTION_AUTO_REFILL_VARIANT_ID =
    54522855031107;

  var SUBSCRIPTION_AUTO_REFILL_SELLING_PLAN_ID =
    691727925571;


  function setButtonBusy(button, isBusy) {

    if (!button) return;

    button.dataset.busy =
      isBusy ? 'true' : 'false';

  }


  function clearCartIfNeeded() {

    if (!CLEAR_CART_BEFORE_ADD) {
      return Promise.resolve();
    }

    return fetch('/cart/clear.js', {

      method: 'POST',

      headers: {
        'Content-Type':
          'application/json',

        Accept:
          'application/json'
      }

    }).then(function (response) {

      if (!response.ok) {
        throw new Error(
          'Unable to clear cart'
        );
      }

      return response.json();

    });

  }


  function triggerCartRefreshEvents() {

    document.documentElement.dispatchEvent(

      new CustomEvent(
        'cart:refresh',
        {
          bubbles: true
        }
      )

    );


    document.dispatchEvent(

      new CustomEvent(
        'cart:updated',
        {
          bubbles: true
        }
      )

    );


    document.dispatchEvent(

      new CustomEvent(
        'cart:change',
        {
          bubbles: true
        }
      )

    );

  }


  function buildCartItems(
    variantId,
    sellingPlanId,
    productType
  ) {

    var items = [

      {
        id:
          parseInt(
            variantId,
            10
          ),

        quantity: 1,

        selling_plan:
          parseInt(
            sellingPlanId,
            10
          ),

        properties: {

          _trybee: true,

          _trybee_product_type:
            productType

        }
      }

    ];


    if (
      productType ===
      'subscribe'
    ) {

      items.push(

        {
          id:
            SUBSCRIPTION_EBOOK_VARIANT_ID,

          quantity: 1,

          properties: {
            _punctual_subscription_gift:
              true
          }
        },

        {
          id:
            SUBSCRIPTION_AUTO_REFILL_VARIANT_ID,

          quantity: 1,

          selling_plan:
            SUBSCRIPTION_AUTO_REFILL_SELLING_PLAN_ID,

          properties: {
            _punctual_subscription_auto_refill:
              true
          }
        }

      );

    }


    return items;

  }


  function addTryBeeProductToCheckout(
    root,
    button,
    variantId,
    productType
  ) {

    var sellingPlanId =
      root.getAttribute(
        'data-trybee-selling-plan-id'
      );


    if (
      !variantId ||
      !sellingPlanId
    ) {

      console.warn(
        '[Punctual TBYB] Missing variant ID or TryBee selling plan ID.'
      );

      return;

    }


    setButtonBusy(
      button,
      true
    );


    clearCartIfNeeded()

      .then(function () {

        return fetch(
          '/cart/add.js',
          {

            method:
              'POST',

            headers: {

              'Content-Type':
                'application/json',

              Accept:
                'application/json'

            },

            body:
              JSON.stringify({

                items:
                  buildCartItems(
                    variantId,
                    sellingPlanId,
                    productType
                  )

              })

          }
        );

      })


      .then(function (response) {

        return response
          .json()
          .then(function (data) {

            if (
              !response.ok ||
              (
                data.status &&
                data.status !== 200
              )
            ) {

              throw new Error(

                data.description ||
                'Error adding products to cart'

              );

            }

            return data;

          });

      })


      .then(function () {

        return fetch(
          '/cart/update.js',
          {

            method:
              'POST',

            headers: {

              'Content-Type':
                'application/json',

              Accept:
                'application/json'

            },

            body:
              JSON.stringify({

                attributes: {
                  _trybee: true
                }

              })

          }
        );

      })


      .then(function (response) {

        if (!response.ok) {

          throw new Error(
            'Unable to update cart attributes'
          );

        }


        triggerCartRefreshEvents();


        window.location.assign(
          '/checkout'
        );

      })


      .catch(function (error) {

        console.warn(
          '[Punctual TBYB] Checkout preparation failed:',
          error
        );


        setButtonBusy(
          button,
          false
        );


        window.alert(
          'We could not prepare your order. Please try again.'
        );

      });

  }


  function init(root) {

    if (
      !root ||
      root.dataset.tbybInit ===
        'true'
    ) {
      return;
    }


    root.dataset.tbybInit =
      'true';


    var mainImg =
      root.querySelector(
        '.tbyb__main-img'
      );


    var thumbs =
      root.querySelectorAll(
        '.tbyb__thumb'
      );


    var mobileTrack =
      root.querySelector(
        '[data-mobile-track]'
      );


    var mobileSlides =
      root.querySelectorAll(
        '.tbyb__mobile-slide'
      );


    function setActiveThumb(
      activeThumb
    ) {

      thumbs.forEach(
        function (thumb) {

          thumb.classList.remove(
            'is-active'
          );

          thumb.setAttribute(
            'aria-selected',
            'false'
          );

        }
      );


      activeThumb
        .classList
        .add(
          'is-active'
        );


      activeThumb
        .setAttribute(
          'aria-selected',
          'true'
        );

    }


    thumbs.forEach(
      function (thumb, index) {

        thumb.addEventListener(
          'click',
          function () {

            var url =
              this.getAttribute(
                'data-image'
              );


            if (
              url &&
              mainImg
            ) {

              mainImg.src =
                url;

            }


            if (
              mobileTrack &&
              mobileSlides[index]
            ) {

              mobileTrack.scrollTo({

                left:
                  mobileSlides[index]
                    .offsetLeft,

                behavior:
                  'smooth'

              });

            }


            setActiveThumb(
              this
            );

          }
        );

      }
    );


    if (
      mobileTrack &&
      mobileSlides.length &&
      thumbs.length
    ) {

      mobileTrack.addEventListener(
        'scroll',
        function () {

          window.requestAnimationFrame(
            function () {

              var slideWidth =
                mobileTrack.offsetWidth;


              if (!slideWidth) {
                return;
              }


              var activeIndex =
                Math.round(

                  mobileTrack.scrollLeft /
                  slideWidth

                );


              var activeThumb =
                thumbs[
                  activeIndex
                ];


              if (
                activeThumb
              ) {

                setActiveThumb(
                  activeThumb
                );

              }

            }
          );

        }
      );

    }


    var dots =
      root.querySelectorAll(
        '[data-dot]'
      );


    var slides =
      root.querySelectorAll(
        '[data-slide]'
      );


    dots.forEach(
      function (dot) {

        dot.addEventListener(
          'click',
          function () {

            var index =
              dot.getAttribute(
                'data-dot'
              );


            slides.forEach(
              function (slide) {

                slide
                  .classList
                  .toggle(

                    'is-active',

                    slide
                      .getAttribute(
                        'data-slide'
                      ) ===
                      index

                  );

              }
            );


            dots.forEach(
              function (
                dotItem
              ) {

                dotItem
                  .classList
                  .toggle(

                    'is-active',

                    dotItem ===
                      dot

                  );

              }
            );

          }
        );

      }
    );


    var optionCards =
      root.querySelectorAll(
        '[data-option-card]'
      );


    var planInputs =
      root.querySelectorAll(
        '.tbyb__input'
      );


    planInputs.forEach(
      function (input) {

        input.addEventListener(
          'change',
          function () {

            optionCards
              .forEach(
                function (
                  card
                ) {

                  var cardInput =
                    card.querySelector(
                      '.tbyb__input'
                    );


                  card
                    .classList
                    .toggle(

                      'is-selected',

                      cardInput &&
                      cardInput.checked

                    );

                }
              );

          }
        );

      }
    );


    var modal =
      root.querySelector(
        '[data-how-modal]'
      );


    var openModalButtons =
      root.querySelectorAll(
        '[data-open-how-modal]'
      );


    var closeModalButtons =
      root.querySelectorAll(
        '[data-close-how-modal]'
      );


    function openModal() {

      if (!modal) {
        return;
      }


      modal
        .classList
        .add(
          'is-open'
        );


      modal
        .setAttribute(
          'aria-hidden',
          'false'
        );


      document
        .body
        .classList
        .add(
          'tbyb-modal-open'
        );

    }


    function closeModal() {

      if (!modal) {
        return;
      }


      modal
        .classList
        .remove(
          'is-open'
        );


      modal
        .setAttribute(
          'aria-hidden',
          'true'
        );


      document
        .body
        .classList
        .remove(
          'tbyb-modal-open'
        );

    }


    openModalButtons
      .forEach(
        function (
          button
        ) {

          button.addEventListener(
            'click',
            openModal
          );

        }
      );


    closeModalButtons
      .forEach(
        function (
          button
        ) {

          button.addEventListener(
            'click',
            closeModal
          );

        }
      );


    document
      .addEventListener(
        'keydown',
        function (event) {

          if (

            event.key ===
              'Escape' &&

            modal &&

            modal
              .classList
              .contains(
                'is-open'
              )

          ) {

            closeModal();

          }

        }
      );


    var cta =
      root.querySelector(
        '.tbyb__cta'
      );


    if (!cta) {
      return;
    }


    cta.addEventListener(
      'click',
      function () {

        if (
          cta.dataset.busy ===
          'true'
        ) {
          return;
        }


        var checked =
          root.querySelector(
            '.tbyb__input:checked'
          );


        var selectedPlan =
          checked
            ? checked.value
            : 'subscribe';


        if (
          selectedPlan ===
          'once'
        ) {

          var otpVariantId =
            root.getAttribute(
              'data-otp-variant-id'
            );


          addTryBeeProductToCheckout(

            root,

            cta,

            otpVariantId,

            'otp'

          );


          return;

        }


        var subVariantId =
          root.getAttribute(
            'data-variant-id'
          );


        addTryBeeProductToCheckout(

          root,

          cta,

          subVariantId,

          'subscribe'

        );

      }
    );


    window
      .addEventListener(
        'pageshow',
        function (event) {

          if (
            event.persisted
          ) {

            setButtonBusy(
              cta,
              false
            );

          }

        }
      );

  }


  function initAll() {

    document
      .querySelectorAll(
        '.tbyb'
      )
      .forEach(
        init
      );

  }


  document
    .addEventListener(
      'DOMContentLoaded',
      initAll
    );


  if (
    document.readyState !==
    'loading'
  ) {

    initAll();

  }

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-product-tbyb_upsell"] && !Shopify.designMode) return;
  try {
    

(function () {

  var CLEAR_CART_BEFORE_ADD = true;


  function setButtonBusy(button, isBusy) {

    if (!button) return;

    button.dataset.busy =
      isBusy ? 'true' : 'false';

  }


  function clearCartIfNeeded() {

    if (!CLEAR_CART_BEFORE_ADD) {
      return Promise.resolve();
    }

    return fetch('/cart/clear.js', {

      method: 'POST',

      headers: {
        'Content-Type':
          'application/json',

        Accept:
          'application/json'
      }

    }).then(function (response) {

      if (!response.ok) {
        throw new Error(
          'Unable to clear cart'
        );
      }

      return response.json();

    });

  }


  function triggerCartRefreshEvents() {

    document.documentElement.dispatchEvent(

      new CustomEvent(
        'cart:refresh',
        {
          bubbles: true
        }
      )

    );


    document.dispatchEvent(

      new CustomEvent(
        'cart:updated',
        {
          bubbles: true
        }
      )

    );


    document.dispatchEvent(

      new CustomEvent(
        'cart:change',
        {
          bubbles: true
        }
      )

    );

  }


  function addTryBeeProductToCheckout(
    root,
    button,
    variantId,
    productType,
    quantity,
    extraItems
  ) {

    var sellingPlanId =
      root.getAttribute(
        'data-trybee-selling-plan-id'
      );

    var selectedQuantity =
      parseInt(quantity, 10) || 1;


    if (
      !variantId ||
      !sellingPlanId
    ) {

      console.error(
        '[Punctual TBYB] Missing variant ID or TryBee selling plan ID.',
        { variantId: variantId, sellingPlanId: sellingPlanId, productType: productType }
      );

      window.alert(
        'We could not start your trial — ' +
        (!variantId ? 'the product variant' : 'the TryBee selling plan ID') +
        ' is missing on this page. Please refresh and try again, or contact us if this keeps happening.'
      );

      return;

    }


    setButtonBusy(
      button,
      true
    );

    var items = [
      {
        id: parseInt(variantId, 10),
        quantity: selectedQuantity,
        selling_plan: parseInt(sellingPlanId, 10),
        properties: {
          _trybee: true,
          _trybee_product_type: productType,
          _trybee_quantity_offer: selectedQuantity
        }
      }
    ];

    if (Array.isArray(extraItems) && extraItems.length) {
      items = items.concat(extraItems);
    }


    clearCartIfNeeded()

      .then(function () {

        return fetch(
          '/cart/add.js',
          {

            method:
              'POST',

            headers: {

              'Content-Type':
                'application/json',

              Accept:
                'application/json'

            },

            body:
              JSON.stringify({

                items: items

              })

          }
        );

      })


      .then(function (response) {

        return response
          .json()
          .then(function (data) {

            if (
              !response.ok ||
              (
                data.status &&
                data.status !== 200
              )
            ) {

              console.error(
                '[Punctual TBYB] /cart/add.js rejected the request.',
                { items: items, response: data }
              );

              throw new Error(

                data.description ||
                'Error adding products to cart'

              );

            }

            return data;

          });

      })


      .then(function () {

        return fetch(
          '/cart/update.js',
          {

            method:
              'POST',

            headers: {

              'Content-Type':
                'application/json',

              Accept:
                'application/json'

            },

            body:
              JSON.stringify({

                attributes: {
                  _trybee: true
                }

              })

          }
        );

      })


      .then(function (response) {

        if (!response.ok) {

          throw new Error(
            'Unable to update cart attributes'
          );

        }


        triggerCartRefreshEvents();


        window.location.assign(
          '/checkout'
        );

      })


      .catch(function (error) {

        console.error(
          '[Punctual TBYB] Checkout preparation failed:',
          error
        );


        setButtonBusy(
          button,
          false
        );


        window.alert(
          'We could not prepare your order: ' + (error && error.message ? error.message : 'please try again.')
        );

      });

  }


  function init(root) {

    if (
      !root ||
      root.dataset.tbybInit ===
        'true'
    ) {
      return;
    }


    root.dataset.tbybInit =
      'true';


    var mainImg =
      root.querySelector(
        '.tbyb__main-img'
      );


    var thumbs =
      root.querySelectorAll(
        '.tbyb__thumb'
      );


    var mobileTrack =
      root.querySelector(
        '[data-mobile-track]'
      );


    var mobileSlides =
      root.querySelectorAll(
        '.tbyb__mobile-slide'
      );


    function setActiveThumb(
      activeThumb
    ) {

      thumbs.forEach(
        function (thumb) {

          thumb.classList.remove(
            'is-active'
          );

          thumb.setAttribute(
            'aria-selected',
            'false'
          );

        }
      );


      activeThumb
        .classList
        .add(
          'is-active'
        );


      activeThumb
        .setAttribute(
          'aria-selected',
          'true'
        );

    }


    thumbs.forEach(
      function (thumb, index) {

        thumb.addEventListener(
          'click',
          function () {

            var url =
              this.getAttribute(
                'data-image'
              );


            if (
              url &&
              mainImg
            ) {

              mainImg.src =
                url;

            }


            if (
              mobileTrack &&
              mobileSlides[index]
            ) {

              mobileTrack.scrollTo({

                left:
                  mobileSlides[index]
                    .offsetLeft,

                behavior:
                  'smooth'

              });

            }


            setActiveThumb(
              this
            );

          }
        );

      }
    );


    if (
      mobileTrack &&
      mobileSlides.length &&
      thumbs.length
    ) {

      mobileTrack.addEventListener(
        'scroll',
        function () {

          window.requestAnimationFrame(
            function () {

              var slideWidth =
                mobileTrack.offsetWidth;


              if (!slideWidth) {
                return;
              }


              var activeIndex =
                Math.round(

                  mobileTrack.scrollLeft /
                  slideWidth

                );


              var activeThumb =
                thumbs[
                  activeIndex
                ];


              if (
                activeThumb
              ) {

                setActiveThumb(
                  activeThumb
                );

              }

            }
          );

        }
      );

    }


    var dots =
      root.querySelectorAll(
        '[data-dot]'
      );


    var slides =
      root.querySelectorAll(
        '[data-slide]'
      );


    dots.forEach(
      function (dot) {

        dot.addEventListener(
          'click',
          function () {

            var index =
              dot.getAttribute(
                'data-dot'
              );


            slides.forEach(
              function (slide) {

                slide
                  .classList
                  .toggle(

                    'is-active',

                    slide
                      .getAttribute(
                        'data-slide'
                      ) ===
                      index

                  );

              }
            );


            dots.forEach(
              function (
                dotItem
              ) {

                dotItem
                  .classList
                  .toggle(

                    'is-active',

                    dotItem ===
                      dot

                  );

              }
            );

          }
        );

      }
    );


    var optionCards =
      root.querySelectorAll(
        '[data-option-card]'
      );


    var planInputs =
      root.querySelectorAll(
        '.tbyb__input'
      );


    planInputs.forEach(
      function (input) {

        input.addEventListener(
          'change',
          function () {

            optionCards
              .forEach(
                function (
                  card
                ) {

                  var cardInput =
                    card.querySelector(
                      '.tbyb__input'
                    );


                  card
                    .classList
                    .toggle(

                      'is-selected',

                      cardInput &&
                      cardInput.checked

                    );

                }
              );

          }
        );

      }
    );


    var modal =
      root.querySelector(
        '[data-how-modal]'
      );


    var openModalButtons =
      root.querySelectorAll(
        '[data-open-how-modal]'
      );


    var closeModalButtons =
      root.querySelectorAll(
        '[data-close-how-modal]'
      );


    function openModal() {

      if (!modal) {
        return;
      }


      modal
        .classList
        .add(
          'is-open'
        );


      modal
        .setAttribute(
          'aria-hidden',
          'false'
        );


      document
        .body
        .classList
        .add(
          'tbyb-modal-open'
        );

    }


    function closeModal() {

      if (!modal) {
        return;
      }


      modal
        .classList
        .remove(
          'is-open'
        );


      modal
        .setAttribute(
          'aria-hidden',
          'true'
        );


      document
        .body
        .classList
        .remove(
          'tbyb-modal-open'
        );

    }


    openModalButtons
      .forEach(
        function (
          button
        ) {

          button.addEventListener(
            'click',
            openModal
          );

        }
      );


    closeModalButtons
      .forEach(
        function (
          button
        ) {

          button.addEventListener(
            'click',
            closeModal
          );

        }
      );


    document
      .addEventListener(
        'keydown',
        function (event) {

          if (

            event.key ===
              'Escape' &&

            modal &&

            modal
              .classList
              .contains(
                'is-open'
              )

          ) {

            closeModal();

          }

        }
      );


    var cta =
      root.querySelector(
        '.tbyb__cta'
      );

    var upsell =
      root.querySelector(
        '[data-tbyb-upsell]'
      );

    var upsellContinue =
      root.querySelector(
        '[data-tbyb-upsell-continue]'
      );

    var upsellSkip =
      root.querySelector(
        '[data-tbyb-upsell-skip]'
      );

    var upsellCloseButtons =
      root.querySelectorAll(
        '[data-close-tbyb-upsell]'
      );

    var quantityInput =
      root.querySelector(
        '[data-tbyb-quantity]'
      );


    if (!cta) {
      return;
    }


    function getSelectedPlan() {

      var checked =
        root.querySelector(
          '.tbyb__input:checked'
        );

      return checked
        ? checked.value
        : 'subscribe';

    }


    function openUpsell() {

      if (!upsell) return;

      upsell.setAttribute(
        'data-plan',
        getSelectedPlan()
      );

      upsell.classList.add('is-open');
      upsell.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tbyb-upsell-open');

    }


    function closeUpsell() {

      if (!upsell) return;

      upsell.classList.remove('is-open');
      upsell.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tbyb-upsell-open');

    }


    // Decline / base path. Reached either by the popup's Skip button, or
    // directly from the CTA when the quantity-upsell popup is disabled.
    // Adds only the trial line — no eBook, no Auto-Refill.
    function submitDefaultSelection() {

      var selectedPlan =
        getSelectedPlan();

      var variantId =
        selectedPlan === 'once'
          ? root.getAttribute('data-otp-variant-id')
          : root.getAttribute('data-variant-id');

      var productType =
        selectedPlan === 'once'
          ? 'otp'
          : 'subscribe';

      if (quantityInput) quantityInput.value = 1;

      closeUpsell();

      addTryBeeProductToCheckout(
        root,
        cta,
        variantId,
        productType,
        1
      );

    }


    // Accept path — the popup's upgrade offer. Subscribe upgrades 1x -> 2x
    // per week; Try Once upgrades 4-pack -> 8-pack. Adds only the trial
    // line at the upgraded quantity — no eBook, no Auto-Refill.
    function submitUpsellAccept() {

      var plan = getSelectedPlan();
      var variantId;
      var quantity = 1;
      var productType;

      if (plan === 'subscribe') {
        variantId = root.getAttribute('data-upsell-variant-id');
        quantity = parseInt(root.getAttribute('data-upsell-line-quantity'), 10) || 2;
        productType = 'upsell_2x';
      } else {
        variantId = root.getAttribute('data-otp-8pack-variant-id');
        quantity = parseInt(root.getAttribute('data-otp-8pack-quantity'), 10) || 2;
        productType = 'otp_8pack';
      }

      if (!variantId) {
        submitDefaultSelection();
        return;
      }

      if (quantityInput) quantityInput.value = quantity;

      closeUpsell();

      addTryBeeProductToCheckout(
        root,
        cta,
        variantId,
        productType,
        quantity
      );

    }


    cta.addEventListener(
      'click',
      function () {

        if (
          cta.dataset.busy ===
          'true'
        ) {
          return;
        }

        if (root.getAttribute('data-enable-quantity-upsell') === 'true') {
          openUpsell();
        } else {
          submitDefaultSelection();
        }

      }
    );


    if (upsellContinue) {
      upsellContinue.addEventListener('click', function () {
        submitUpsellAccept();
      });
    }

    if (upsellSkip) {
      upsellSkip.addEventListener('click', function () {
        submitDefaultSelection();
      });
    }

    upsellCloseButtons.forEach(function (button) {
      button.addEventListener('click', closeUpsell);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && upsell && upsell.classList.contains('is-open')) {
        closeUpsell();
      }
    });


    window
      .addEventListener(
        'pageshow',
        function (event) {

          if (
            event.persisted
          ) {

            setButtonBusy(
              cta,
              false
            );

            closeUpsell();

          }

        }
      );

  }


  function initAll() {

    document
      .querySelectorAll(
        '.tbyb'
      )
      .forEach(
        init
      );

  }


  document
    .addEventListener(
      'DOMContentLoaded',
      initAll
    );


  if (
    document.readyState !==
    'loading'
  ) {

    initAll();

  }

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function toId(value) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? null : parsed;
  }

  function setButtonBusy(button, isBusy) {
    if (!button) return;
    button.dataset.busy = isBusy ? 'true' : 'false';
  }

  function addToCart(root, button, plan) {
    var item;

    if (plan === 'once') {
      var otpId = toId(root.getAttribute('data-otp-variant-id'));
      if (!otpId) { console.warn('[Punctual Offer] Missing OTP variant ID.'); return; }
      item = { id: otpId, quantity: 1 };
    } else {
      var subId = toId(root.getAttribute('data-sub-variant-id'));
      var subPlanId = toId(root.getAttribute('data-sub-selling-plan-id'));
      if (!subId) { console.warn('[Punctual Offer] Missing subscription variant ID.'); return; }
      item = { id: subId, quantity: 1 };
      if (subPlanId) item.selling_plan = subPlanId;
    }

    var destination =
      root.getAttribute('data-destination') === 'cart' ? '/cart' : '/checkout';

    setButtonBusy(button, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || (data.status && data.status !== 200)) {
            throw new Error(data.description || 'Error adding to cart');
          }
          return data;
        });
      })
      .then(function () {
        window.location.assign(destination);
      })
      .catch(function (error) {
        console.warn('[Punctual Offer] Add to cart failed:', error);
        setButtonBusy(button, false);
        window.alert('We could not add this to your bag. Please try again.');
      });
  }

  function init(root) {
    if (!root || root.dataset.offerInit === 'true') return;
    root.dataset.offerInit = 'true';

    var mainImg = root.querySelector('.offer__main-img');
    var thumbs = root.querySelectorAll('.offer__thumb');
    var mobileTrack = root.querySelector('[data-mobile-track]');
    var mobileSlides = root.querySelectorAll('.offer__mobile-slide');

    function setActiveThumb(activeThumb) {
      thumbs.forEach(function (thumb) {
        thumb.classList.remove('is-active');
        thumb.setAttribute('aria-selected', 'false');
      });

      activeThumb.classList.add('is-active');
      activeThumb.setAttribute('aria-selected', 'true');
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        var url = this.getAttribute('data-image');

        if (url && mainImg) {
          mainImg.src = url;
        }

        if (mobileTrack && mobileSlides[index]) {
          mobileTrack.scrollTo({
            left: mobileSlides[index].offsetLeft,
            behavior: 'smooth'
          });
        }

        setActiveThumb(this);
      });
    });

    if (mobileTrack && mobileSlides.length && thumbs.length) {
      mobileTrack.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () {
          var slideWidth = mobileTrack.offsetWidth;
          if (!slideWidth) return;

          var activeIndex = Math.round(mobileTrack.scrollLeft / slideWidth);
          var activeThumb = thumbs[activeIndex];

          if (activeThumb) {
            setActiveThumb(activeThumb);
          }
        });
      });
    }

    var dots = root.querySelectorAll('[data-dot]');
    var slides = root.querySelectorAll('[data-slide]');

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = dot.getAttribute('data-dot');

        slides.forEach(function (slide) {
          slide.classList.toggle(
            'is-active',
            slide.getAttribute('data-slide') === index
          );
        });

        dots.forEach(function (dotItem) {
          dotItem.classList.toggle('is-active', dotItem === dot);
        });
      });
    });

    // Option card selection
    var optionCards = root.querySelectorAll('[data-option-card]');
    var planInputs = root.querySelectorAll('input[name="offer-plan"]');

    planInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        optionCards.forEach(function (card) {
          var cardInput = card.querySelector('input[name="offer-plan"]');
          card.classList.toggle('is-selected', cardInput && cardInput.checked);
        });
      });
    });

    // Add to cart
    var cta = root.querySelector('.offer__cta');
    if (cta) {
      cta.addEventListener('click', function () {
        if (cta.dataset.busy === 'true') return;

        var checked = root.querySelector('input[name="offer-plan"]:checked');
        var plan = checked ? checked.value : 'subscribe';

        addToCart(root, cta, plan === 'once' ? 'once' : 'subscribe');
      });

      window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
          setButtonBusy(cta, false);
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.offer').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  if (document.readyState !== 'loading') {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-tbyb"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CLEAR_CART_BEFORE_ADD = true;

  var SUBSCRIPTION_EBOOK_VARIANT_ID = 54686607606083;
  var SUBSCRIPTION_AUTO_REFILL_VARIANT_ID = 54522855031107;
  var SUBSCRIPTION_AUTO_REFILL_SELLING_PLAN_ID = 691727925571;

  function setButtonBusy(button, isBusy) {
    if (!button) return;
    button.dataset.busy = isBusy ? 'true' : 'false';
  }

  function clearCartIfNeeded() {
    if (!CLEAR_CART_BEFORE_ADD) return Promise.resolve();

    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to clear cart');
      }

      return response.json();
    });
  }

  function triggerCartRefreshEvents() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );

    document.dispatchEvent(
      new CustomEvent('cart:updated', { bubbles: true })
    );

    document.dispatchEvent(
      new CustomEvent('cart:change', { bubbles: true })
    );
  }

  function buildCartItems(variantId, sellingPlanId, productType) {
    var items = [
      {
        id: parseInt(variantId, 10),
        quantity: 1,
        selling_plan: parseInt(sellingPlanId, 10),
        properties: {
          _trybee: true,
          _trybee_product_type: productType
        }
      }
    ];

    /*
     * These two items apply only to Subscribe & Save.
     * Adding all three lines in one request avoids waiting for the
     * promotion app before redirecting to checkout.
     */
    if (productType === 'subscribe') {
      items.push(
        {
          id: SUBSCRIPTION_EBOOK_VARIANT_ID,
          quantity: 1,
          properties: {
            _punctual_subscription_gift: true
          }
        },
        {
          id: SUBSCRIPTION_AUTO_REFILL_VARIANT_ID,
          quantity: 1,
          selling_plan: SUBSCRIPTION_AUTO_REFILL_SELLING_PLAN_ID,
          properties: {
            _punctual_subscription_auto_refill: true
          }
        }
      );
    }

    return items;
  }

  function addTryBeeProductToCheckout(root, button, variantId, productType) {
    var sellingPlanId = root.getAttribute('data-trybee-selling-plan-id');

    if (!variantId || !sellingPlanId) {
      console.warn(
        '[Punctual TBYB] Missing variant ID or TryBee selling plan ID.'
      );
      return;
    }

    setButtonBusy(button, true);

    clearCartIfNeeded()
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: buildCartItems(variantId, sellingPlanId, productType)
          })
        });
      })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || (data.status && data.status !== 200)) {
            throw new Error(
              data.description || 'Error adding products to cart'
            );
          }

          return data;
        });
      })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              _trybee: true
            }
          })
        });
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to update cart attributes');
        }

        triggerCartRefreshEvents();
        window.location.assign('/checkout');
      })
      .catch(function (error) {
        console.warn('[Punctual TBYB] Checkout preparation failed:', error);
        setButtonBusy(button, false);

        window.alert(
          'We could not prepare your order. Please try again.'
        );
      });
  }

  function init(root) {
    if (!root || root.dataset.tbybInit === 'true') return;
    root.dataset.tbybInit = 'true';

    var mainImg = root.querySelector('.tbyb__main-img');
    var thumbs = root.querySelectorAll('.tbyb__thumb');
    var mobileTrack = root.querySelector('[data-mobile-track]');
    var mobileSlides = root.querySelectorAll('.tbyb__mobile-slide');

    function setActiveThumb(activeThumb) {
      thumbs.forEach(function (thumb) {
        thumb.classList.remove('is-active');
        thumb.setAttribute('aria-selected', 'false');
      });

      activeThumb.classList.add('is-active');
      activeThumb.setAttribute('aria-selected', 'true');
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        var url = this.getAttribute('data-image');

        if (url && mainImg) {
          mainImg.src = url;
        }

        if (mobileTrack && mobileSlides[index]) {
          mobileTrack.scrollTo({
            left: mobileSlides[index].offsetLeft,
            behavior: 'smooth'
          });
        }

        setActiveThumb(this);
      });
    });

    if (mobileTrack && mobileSlides.length && thumbs.length) {
      mobileTrack.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () {
          var slideWidth = mobileTrack.offsetWidth;
          if (!slideWidth) return;

          var activeIndex = Math.round(mobileTrack.scrollLeft / slideWidth);
          var activeThumb = thumbs[activeIndex];

          if (activeThumb) {
            setActiveThumb(activeThumb);
          }
        });
      });
    }

    var dots = root.querySelectorAll('[data-dot]');
    var slides = root.querySelectorAll('[data-slide]');

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = dot.getAttribute('data-dot');

        slides.forEach(function (slide) {
          slide.classList.toggle(
            'is-active',
            slide.getAttribute('data-slide') === index
          );
        });

        dots.forEach(function (dotItem) {
          dotItem.classList.toggle('is-active', dotItem === dot);
        });
      });
    });

    var optionCards = root.querySelectorAll('[data-option-card]');
    var planInputs = root.querySelectorAll('input[name="tbyb-plan"]');

    planInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        optionCards.forEach(function (card) {
          var cardInput = card.querySelector('input[name="tbyb-plan"]');
          card.classList.toggle(
            'is-selected',
            cardInput && cardInput.checked
          );
        });
      });
    });

    var modal = root.querySelector('[data-how-modal]');
    var openModalButtons = root.querySelectorAll('[data-open-how-modal]');
    var closeModalButtons = root.querySelectorAll('[data-close-how-modal]');

    function openModal() {
      if (!modal) return;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tbyb-modal-open');
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tbyb-modal-open');
    }

    openModalButtons.forEach(function (button) {
      button.addEventListener('click', openModal);
    });

    closeModalButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (
        event.key === 'Escape' &&
        modal &&
        modal.classList.contains('is-open')
      ) {
        closeModal();
      }
    });

    var cta = root.querySelector('.tbyb__cta');
    if (!cta) return;

    cta.addEventListener('click', function () {
      if (cta.dataset.busy === 'true') return;

      var checked = root.querySelector('input[name="tbyb-plan"]:checked');
      var selectedPlan = checked ? checked.value : 'subscribe';

      if (selectedPlan === 'once') {
        var otpVariantId = root.getAttribute('data-otp-variant-id');
        addTryBeeProductToCheckout(root, cta, otpVariantId, 'otp');
        return;
      }

      var subVariantId = root.getAttribute('data-variant-id');
      addTryBeeProductToCheckout(
        root,
        cta,
        subVariantId,
        'subscribe'
      );
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        setButtonBusy(cta, false);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.tbyb').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  if (document.readyState !== 'loading') {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
